import Vue from 'vue'
import VueRouter from 'vue-router'
import mainRoutes from './mainRoutes'
import VueMeta from 'vue-meta'
import a from 'axios'
import config from './../config'
import { store } from '@/store/index'
import { MODULE_USER, SET_USER_RIGHTS } from '../store/constant/mutation-types'
const prefixEndpoint = config.apiBaseUrl
const headers = {
  'Content-Type': 'application/json'
}
Vue.use(VueRouter)
Vue.use(VueMeta)

const routes = [].concat(mainRoutes)

const router = new VueRouter({
  routes,
  mode: 'history'
})

router.onReady(() => {
  const token = localStorage.getItem('token')
  if (token && !store.getters.getPreloadState) store.dispatch('preloadApp')
})

const checkRouteAccess = async (to, next) => {
  const checkRight = rightName => store.getters['user/getUserRight'](rightName)
  const replaceToErrorPage = () => {
    router.push({ name: 'error' })
  }
  const checkRoute = (toRoute, nextFunction) => {
    if (toRoute.meta.rightKey) {
      if (toRoute.meta.category !== 'inventory') {
        if (checkRight(toRoute.meta.rightKey)) {
          nextFunction()
        } else {
          if (toRoute.name !== 'Inventory') {
            replaceToErrorPage()
          }
        }
      } else {
        if (checkRight('warehouseView') && (checkRight('itemView') || checkRight('categoryView'))) {
          if (toRoute.name === 'Inventory') {
            nextFunction()
          } else {
            if (checkRight(toRoute.meta.rightKey)) {
              nextFunction()
            } else replaceToErrorPage()
          }
        } else {
          if (toRoute.name !== 'Inventory') {
            replaceToErrorPage()
          }
        }
      }
    } else {
      nextFunction()
    }
  }
  if (store.getters['user/getUserRight']('loaded')) {
    checkRoute(to, next)
  } else {
    await store.subscribe(mutation => {
      if (mutation.type === `user/${SET_USER_RIGHTS}`) {
        checkRoute(to, next)
      }
    })
  }
}

router.beforeEach((to, from, next) => {
  const token = localStorage.getItem('token')
  store.commit('settings/setActiveMenuItem', to.meta.menuName)

  if (token) {
    checkRouteAccess(to, next)
  }

  if (token && !store.getters.getPreloadState) store.dispatch('preloadApp')
  if (token && !store.getters[`${MODULE_USER}/user`]) {
    const curUserData = localStorage.getItem('curUserData')
    store.commit(`${MODULE_USER}/set`, { type: 'curUserData', val: JSON.parse(curUserData) })
  }

  if ((to.path === '/mobile/pricing' || to.path === '/login') && !token && to.query.token) {
    localStorage.setItem('querytoken', to.query.token)
  }

  if (token && (to.path === '/login' || to.path === '/register')) {
    const redirectAfterAuthorization = (localStorage.getItem('redirectAfterAuthorization'))
    if (redirectAfterAuthorization) {
      localStorage.removeItem('redirectAfterAuthorization')
      window.location = redirectAfterAuthorization
    } else if (store.getters.getRouteAfterLogin) {
      next({ name: store.getters.getRouteAfterLogin })
    } else {
      next({ name: 'Dashboard' })
    }
  }

  if (to.path === '/forgotPassword') {
    const payload = {
      email: to.query.email,
      token: to.query.token
    }
    a.post(prefixEndpoint + 'password/recovery', payload, headers)
      .then((res) => {
        if (res.data.error.type === 200) {
          localStorage.setItem('verificationData', JSON.stringify(payload))
          next({ name: 'passwordForgot' })
        } else {
          next({ name: 'Login' })
        }
      })
  }

  if (to.path === '/invite/accept') {
    const payload = {
      email: to.query.email,
      token: to.query.token
    }
    a.post(prefixEndpoint + 'invite/accept', payload, headers)
      .then((res) => {
        if (res.data.error.type === 200) {
          localStorage.setItem('verificationData1', JSON.stringify(payload))
          next({ name: 'SetPassword' })
        } else {
          next({ name: 'main' })
        }
      })
  }

  if (token) {
    if (!store.getters['warehouses/getWarehousesLoadingStatus'] || to.name === 'Warehouses') {
      store.dispatch('warehouses/loadWarehousesList')
    }
  }
  if (to.matched.some(p => p.meta.requiresAuth) && !token) {
    const routeAfterLogin = to.name === 'Subscription' ? to : null
    store.dispatch(
      'setRouteAfterLogin',
      routeAfterLogin, { root: true })
    next({ name: 'Login' })
  }
  next()
})

export default router
